import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, message, Checkbox, Icon } from 'antd';

import { moveToQaReady, getTemplate } from '../../../utils/services/shortMessageTemplateAPI';
import { DesignModal } from '../styles';
import { sendToTestCheck } from '../../../images/svgIcons';
import { REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL } from './translationValues';
import { IS_WHATSAPP_ENABLED } from '../../../utils/helper';

/* This component allows to send the draft messages of each channel to testing env
  Child Components: 
    *************
*/

const NAMESPACES = ['REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL'];
class SendToTestShortMsg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isSendingToTest: false,
      checkedList: [],
      draftChannels: [],
    };
  }

  componentDidMount = async () => {
    const { isWhatsappEmpty, isSMSEmpty, isCallEmpty } = this.props;
    this.setState({
      isLoading: true,
    });
    this.updateDraftChannels();
    const defaultCheckedList = [];
    if (!isWhatsappEmpty) defaultCheckedList.push('whatsapp');
    if (!isSMSEmpty) defaultCheckedList.push('sms');
    if (!isCallEmpty) defaultCheckedList.push('call');
    this.setState({ checkedList: defaultCheckedList });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isWhatsappEmpty !== prevProps.isWhatsappEmpty ||
      this.props.isSMSEmpty !== prevProps.isSMSEmpty ||
      this.props.isCallEmpty !== prevProps.isCallEmpty
    ) {
      let defaultCheckedList = this.state.checkedList || [];
      if (!this.props.isWhatsappEmpty) defaultCheckedList.push('whatsapp');
      if (!this.props.isSMSEmpty) defaultCheckedList.push('sms');
      if (!this.props.isCallEmpty) defaultCheckedList.push('call');
      this.setState({ checkedList: defaultCheckedList });
    }
  }

  sendToTesting = async () => {
    const { checkedList } = this.state;
    const { templateId, onCancel, t } = this.props;
    this.setState({
      isSendingToTest: true,
    });
    let response = await moveToQaReady(templateId, checkedList);
    if (response) {
      if (response && response.errors && response.errors.length > 0) {
        message.error(response.status);
      } else {
        message.success(
          t(
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.TEMPLATE_SENT_FOR_TESTING_SUCCESS_MESSAGE.key,
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.TEMPLATE_SENT_FOR_TESTING_SUCCESS_MESSAGE.value,
          ),
        );
        onCancel(false);
        this.updateDraftChannels(true);
      }
      this.setState({
        isSendingToTest: false,
      });
    }
  };

  updateDraftChannels = async (isSetDraft = false) => {
    const { templateId, setIsDraft } = this.props;
    const tempResp = await getTemplate(templateId);
    if (tempResp && tempResp.dataCount !== 0) {
      if (!isSetDraft) {
        if (tempResp.data[0].whatsappPublishStatus === 'draft') {
          this.toggleDraftChannel('whatsapp');
        } else {
          this.toggleChannel('whatsapp');
        }
        if (tempResp.data[0].smsPublishStatus === 'draft') {
          this.toggleDraftChannel('sms');
        } else {
          this.toggleChannel('sms');
        }
        if (tempResp.data[0].callPublishStatus === 'draft') {
          this.toggleDraftChannel('call');
        } else {
          this.toggleChannel('call');
        }
      } else {
        setIsDraft(
          tempResp.data[0].whatsappPublishStatus === 'draft' ||
            tempResp.data[0].smsPublishStatus === 'draft' ||
            tempResp.data[0].callPublishStatus === 'draft'
            ? true
            : false,
        );
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  toggleDraftChannel = list => {
    const { draftChannels } = this.state;
    let checkList = draftChannels;
    if (checkList.includes(list)) {
      let newVar = checkList.filter(value => value !== list);
      this.setState({ draftChannels: newVar });
    } else {
      this.setState({ draftChannels: [...checkList, list] });
    }
  };

  toggleChannel = list => {
    const { checkedList } = this.state;
    let checkList = checkedList;
    if (checkList.includes(list)) {
      let newVar = checkList.filter(value => value !== list);
      this.setState({ checkedList: newVar });
    } else {
      this.setState({ checkedList: [...checkList, list] });
    }
  };

  renderChannel = (channel, isEmpty, displayText) => {
    const { checkedList, draftChannels } = this.state;
    const { t } = this.props;
    return (
      draftChannels.includes(channel) && (
        <Checkbox
          style={{ opacity: isEmpty && 0.5 }}
          onChange={() =>
            isEmpty
              ? message.error(
                  displayText +
                    ' ' +
                    t(
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.EMPTY_ERROR_MESSAGE.key,
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.EMPTY_ERROR_MESSAGE.value,
                    ),
                )
              : this.toggleChannel(channel)
          }
        >
          {displayText}
          {checkedList.includes(channel) && (
            <div className="ModalCheck">
              <Icon component={sendToTestCheck} />
            </div>
          )}
        </Checkbox>
      )
    );
  };

  render() {
    const { t, onCancel, isWhatsappEmpty, isSMSEmpty, isCallEmpty } = this.props;
    const { isLoading, isSendingToTest, checkedList, draftChannels } = this.state;
    return (
      <DesignModal
        messageStudio={true}
        title={
          draftChannels.length <= 1
            ? t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CHOOSE_A_CHANNEL_TO_SEND_FOR_TESTING_TITLE
                  .key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CHOOSE_A_CHANNEL_TO_SEND_FOR_TESTING_TITLE
                  .value,
              )
            : t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_FOR_TESTING_TITLE.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_FOR_TESTING_TITLE.value,
              )
        }
        width="600px"
        centered
        maskClosable={false}
        visible={true}
        onCancel={() => onCancel(false)}
        footer={[
          checkedList.length === 0 && !isLoading && (
            <p className="ErrorMsg">
              {t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SELECT_A_CHANNEL_ERROR_MESSAGE.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SELECT_A_CHANNEL_ERROR_MESSAGE.value,
              )}
            </p>
          ),
          <div>
            <Button key="back" onClick={() => onCancel(false)}>
              {t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CANCEL_SEND_TEST_MESSAGE_BUTTON.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CANCEL_SEND_TEST_MESSAGE_BUTTON.value,
              )}
            </Button>
            <Button
              width={'500px'}
              key="Send Test Message"
              type="primary"
              disabled={checkedList.length === 0}
              loading={isSendingToTest}
              onClick={this.sendToTesting}
            >
              {isSendingToTest
                ? t(
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SENDING_FOR_TESTING_BUTTON.key,
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SENDING_FOR_TESTING_BUTTON.value,
                  )
                : t(
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_FOR_TESTING_BUTTON.key,
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_FOR_TESTING_BUTTON.value,
                  )}
            </Button>
          </div>,
        ]}
      >
        {IS_WHATSAPP_ENABLED && this.renderChannel(
          'whatsapp',
          isWhatsappEmpty,
          t(
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.WHATSAPP_MESSAGE_CHANNEL_NAME.key,
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.WHATSAPP_MESSAGE_CHANNEL_NAME.value,
          ),
        )}
        {this.renderChannel(
          'sms',
          isSMSEmpty,
          t(
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SMS_CHANNEL_NAME.key,
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SMS_CHANNEL_NAME.value,
          ),
        )}
        {this.renderChannel(
          'call',
          isCallEmpty,
          t(
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_CHANNEL_NAME.key,
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_CHANNEL_NAME.value,
          ),
        )}
        {isLoading && (
          <p className="Sending-Icon-Text">
            <Icon type="loading" />{' '}
            {t(
              REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.LOADING_MESSAGE.key,
              REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.LOADING_MESSAGE.value,
            )}
          </p>
        )}
      </DesignModal>
    );
  }
}

export default withTranslation(NAMESPACES)(SendToTestShortMsg);
